export const FUTURE_HAZARD_RANGE_LABELS = [
  "0-1[0.0-1.00]",
  "1-2[1.01-2.00]",
  "2-3[2.01-3.00]",
  "3-4[3.01-4.00]",
  "4-5[4.01-5.00]",
  "5-6[5.01-6.00]"
];

export const getFutureHazardLevelIndex = (
  value: number
): number | undefined => {
  if (Number.isNaN(value)) {
    return undefined;
  }

  if (value <= 1) {
    return 1;
  }

  if (value <= 2) {
    return 2;
  }

  if (value <= 3) {
    return 3;
  }

  if (value <= 4) {
    return 4;
  }

  if (value <= 5) {
    return 5;
  }

  return 6;
};
